import { IPublicClientApplication } from "@azure/msal-browser";
import { getToken } from "Components/Functions";
import { LicenceLinkType } from "Components/Types"
import { api } from "./apiConfig"

export const LicenceLinkAPI = {
    add: async function (instance: IPublicClientApplication, data: LicenceLinkType) {
        const apiCall = await api();
        const header = await getToken(instance);
        const response = await apiCall.request({
            url: "LicenceLink/AddDriver",
            method: "POST",
            data,
            headers: { Authorization: header }
        })
        return response.data
    }
}